import type { LeDataChatMessage } from '~/types/leData';

import { formatTableBlockAsMarkdown } from '~/utils/leData/tableBlock';

function pickMarkdownString(payload: Record<string, unknown>, keys: Array<string>): string {
  for (const key of keys) {
    const value = payload[key];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }
  return '';
}

export function textBlockMarkdown(block: NonNullable<LeDataChatMessage['blocks']>[number]): string {
  return pickMarkdownString(block.payload, ['markdown', 'text', 'content', 'message', 'body']);
}

function formatAssistantBlockMarkdown(block: NonNullable<LeDataChatMessage['blocks']>[number]): string {
  if (block.type === 'text' || block.type === 'error') {
    return textBlockMarkdown(block);
  }

  if (block.type === 'sql') {
    const sqlText = pickMarkdownString(block.payload, ['sql', 'content', 'query', 'statement', 'body']);
    return sqlText ? `\`\`\`sql\n${sqlText}\n\`\`\`` : '';
  }

  if (block.type === 'table') {
    return formatTableBlockAsMarkdown(block.payload);
  }

  if (block.type === 'chart' || block.type === 'file') {
    return pickMarkdownString(block.payload, ['markdown', 'text', 'content', 'message', 'body', 'url']);
  }

  return '';
}

export function formatAssistantMessageMarkdown(message: LeDataChatMessage): string {
  const parts = [message.text?.trim(), ...(message.blocks ?? []).map(formatAssistantBlockMarkdown)].filter(
    (part): part is string => Boolean(part?.trim()),
  );

  return parts.join('\n\n');
}
